import axios from 'axios'
import { API_URL } from 'constants/global.constants'

interface AddCreditsParams {
  subscriptionId: number;
  credits: number;
  notes?: string;
}

/**
 * Añade créditos a una suscripción existente
 * @param params Parámetros para añadir créditos
 * @returns Promesa con el resultado de la operación
 */
export const addCreditsToSubscription = async (params: AddCreditsParams) => {
  const { subscriptionId, credits, notes } = params

  // Validar que el ID de suscripción es un número entero positivo
  if (!Number.isInteger(subscriptionId) || subscriptionId <= 0) {
    throw new Error('El ID de suscripción debe ser un número entero positivo');
  }

  // Validar que los créditos son un número entero positivo
  if (!Number.isInteger(credits) || credits <= 0) {
    throw new Error('Los créditos deben ser un número entero positivo');
  }

  try {
    const response = await axios.post(
      `${API_URL}/subscription_company/${subscriptionId}/credits`,
      {
        credits,
        notes,
        transaction_type: 'ADD_CREDITS'
      },
      {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      }
    )

    return response.data
  } catch (error: any) {
    console.error('Error al añadir créditos a la suscripción:', error)

    // Log detailed error response data if available
    if (error.response?.data) {
      console.error('Detalle del error:', error.response.data)
    }

    throw error
  }
}
